// extracted by mini-css-extract-plugin
export default {"bannerContainer":"logo_bannerContainer__i1K8c","backgroundImage":"logo_backgroundImage__d+QHt","overlay":"logo_overlay__stmvW"};